import { Routes, Route } from "react-router-dom";

import RTLLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import "assets/css/Plugins.css";
import Access from "layouts/access";
//import Hotjar from "@hotjar/browser";
import ScrollToTop from "components/router/scrollToTop";
import CommingSoon from "views/comming-soon";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoginError from "views/login-with-qr";
import Onboarding from "views/onboarding";
import Home from "views/home/Home";
import Policy from "views/home/Policy";
import Ibrahim from "views/link/ibrahim";
import Mathieu from "views/link/mathieu";

//Hotjar.init(3583940, 6);
const isMaintenance = false;

const App = () => {
    return (
        <GoogleOAuthProvider clientId="93302069654-i46mknstqor2q0495pctp74017jp9fnb.apps.googleusercontent.com">
            <div>
                {isMaintenance && <CommingSoon />}
                {!isMaintenance && <ScrollToTop />}
                {!isMaintenance && (
                    <Routes>
                        {/* Redirect all trafic to maintenance page */}
                        {/* Internal application */}
                        <Route path="auth/*" element={<AuthLayout />} />
                        <Route path="admin/*" element={<AdminLayout />} />
                        <Route path="/*" element={<AdminLayout />} />
                        <Route path="rtl/*" element={<RTLLayout />} />
                        <Route path="/" element={<Access />} />

                        {/* Externals mobiles experiences */}
                        <Route path="/onboarding" element={<Onboarding />} />
                        <Route path="/reporting" element={<Home print />} />
                        <Route path="/policy" element={<Policy />} />
                        <Route path="/ibrahim" element={<Ibrahim />} />
                        <Route path="/mathieu" element={<Mathieu />} />
                        <Route path="/login-error" element={<LoginError />} />
                    </Routes>
                )}
            </div>
        </GoogleOAuthProvider>
    );
};

export default App;
